import { RootState } from '../index';

// Base selectors - direct data access only
export const selectStudyYearCategoryCompanies = (state: RootState) =>
  state.studyYearCategoryCompanies;

export const selectCurrentStudyYearCategoryCompany = (state: RootState) =>
  state.studyYearCategoryCompanies.currentStudyYearCategoryCompany;

export const selectParentCompany = (state: RootState) =>
  state.studyYearCategoryCompanies.parentCompany;

export const selectCompanyHistory = (state: RootState) =>
  state.studyYearCategoryCompanies.companyHistory;

// Loading states
export const selectStudyYearCategoryCompaniesLoading = (state: RootState) =>
  state.studyYearCategoryCompanies.isLoading;

export const selectStudyYearCategoryCompaniesUpdating = (state: RootState) =>
  state.studyYearCategoryCompanies.isUpdating;

export const selectStudyYearCategoryCompaniesLoadingParent = (state: RootState) =>
  state.studyYearCategoryCompanies.isLoadingParent;

export const selectStudyYearCategoryCompaniesLoadingHistory = (state: RootState) =>
  state.studyYearCategoryCompanies.isLoadingHistory;

// Error state
export const selectStudyYearCategoryCompaniesError = (state: RootState) =>
  state.studyYearCategoryCompanies.error;
